import { generatePath } from 'react-router-dom'
import { CompanyTag } from '@/components/ui/badge'
import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { LeadDtoKey } from 'api/Clients/Types/LeadDto'
import { Link } from 'components/Link'
import { formatLocalDateUTC } from 'utils/date'
import { links } from 'utils/featureToggles'

import { NameDto } from '../../../api/Common/Types'
import { LeadTab } from './Details/LeadSlug'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

export const leadsColumns: GridColumn[] = [
  {
    title: 'Full Name',
    field: LeadDtoKey.name,
    show: true,
    cell: (props: GridCellProps) => (
      <td style={{ color: 'var(--link)', textDecoration: 'underline' }}>
        <Link
          to={{
            pathname: generatePath(links.recordsLeads.detailsUrl as string, {
              id: props.dataItem.id,
              slug: LeadTab.DETAILS,
            }),
          }}
        >
          {props.dataItem.name}
        </Link>
      </td>
    ),
  },
  {
    title: 'Email',
    field: LeadDtoKey.email,
    show: true,
  },
  {
    title: 'Phone number',
    field: LeadDtoKey.phoneNumber,
    className: 'table-columns__number',
    show: true,
  },
  {
    title: 'Birthday',
    field: LeadDtoKey.birthDay,
    show: true,
    cell: (props: GridCellProps) => (
      <td className='table-columns__date'>{formatLocalDateUTC(props.dataItem.birthDay)}</td>
    ),
  },
  {
    title: 'Country',
    field: LeadDtoKey.country,
    show: true,
  },
  {
    title: 'Product',
    field: LeadDtoKey.products,
    cell: (props: GridCellProps): JSX.Element => {
      if (!props?.dataItem?.products.length) {
        return <td />
      }

      return (
        <td>
          {props.dataItem.products.map((p: NameDto) => (
            <p key={p.id}>{p.name}</p>
          ))}
        </td>
      )
    },
    show: true,
  },
  {
    title: 'Converted',
    show: true,
    cell: (props: GridCellProps) => (
      <td className='table-columns__content'>
        {props.dataItem.isConverted ? 'Converted' : 'Not Converted'}
      </td>
    ),
  },
  {
    title: 'Language',
    field: LeadDtoKey.language,
    show: true,
  },
  {
    title: 'Assignee',
    field: LeadDtoKey.assignee,
    cell: (props: GridCellProps): JSX.Element => {
      if (!props.dataItem?.assignee?.name) {
        return <td />
      }
      return <td className='table-columns__content'>{props.dataItem.assignee.name}</td>
    },
    show: true,
  },
  {
    title: 'Entity',
    field: LeadDtoKey.tickmillCompany,
    cell: (props: GridCellProps): JSX.Element => {
      if (!props.dataItem?.tickmillCompany?.id) {
        return <td />
      }
      return (
        <td>
          <CompanyTag id={props.dataItem.tickmillCompany.id}>
            {props.dataItem.tickmillCompany.name}
          </CompanyTag>
        </td>
      )
    },
    show: true,
    width: 80,
    minResizableWidth: 80,
  },
  {
    title: 'Date Created',
    field: LeadDtoKey.created,
    cell: (props: GridCellProps) => (
      <td className='table-columns__date'>{formatLocalDateUTC(props.dataItem.created, true)}</td>
    ),
    show: true,
  },
  {
    title: 'Date Updated',
    field: LeadDtoKey.updated,
    cell: (props: GridCellProps) => (
      <td className='table-columns__date'>{formatLocalDateUTC(props.dataItem.updated, true)}</td>
    ),
    show: true,
    filter: 'text',
  },
]
